import type { NovaEvent } from "@nova/types";
import type { AppHostServiceEventOriginator } from "./originator";

export const UntrapLpcFocusEventType = "untrapLpcFocus" as const;

export interface UntrapLpcFocusEvent extends NovaEvent<unknown> {
    originator: typeof AppHostServiceEventOriginator;
    type: typeof UntrapLpcFocusEventType;
}
